import { render, staticRenderFns } from "./PointHealthPerformance.vue?vue&type=template&id=4f6cfead"
import script from "./PointHealthPerformance.vue?vue&type=script&lang=js"
export * from "./PointHealthPerformance.vue?vue&type=script&lang=js"
import style0 from "./PointHealthPerformance.vue?vue&type=style&index=0&id=4f6cfead&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports